(function () {
  if (window.__AG_PB_PD_FAQ_INIT__) return;
  window.__AG_PB_PD_FAQ_INIT__ = true;

  var ACCORDION_MS = 340;

  function prefersReducedMotion() {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function setItemOpen(item, open) {
    var toggle = item.querySelector('.js-ag-pb-pd-faq-toggle');
    var answer = item.querySelector('.ag-pb-pd__faq-answer');
    item.classList.toggle('is-open', open);
    if (toggle) toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    if (!answer) return;

    if (open) {
      answer.removeAttribute('hidden');
      return;
    }

    if (prefersReducedMotion()) {
      answer.setAttribute('hidden', '');
      return;
    }

    window.setTimeout(function () {
      if (!item.classList.contains('is-open')) {
        answer.setAttribute('hidden', '');
      }
    }, ACCORDION_MS);
  }

  function toggleItem(root, item) {
    if (!item) return;
    var willOpen = !item.classList.contains('is-open');

    root.querySelectorAll('.js-ag-pb-pd-faq-item.is-open').forEach(function (openItem) {
      if (openItem !== item) setItemOpen(openItem, false);
    });

    setItemOpen(item, willOpen);
  }

  function initBlock(root) {
    if (root.dataset.agPbPdFaqReady === 'true') return;
    root.dataset.agPbPdFaqReady = 'true';

    root.addEventListener('click', function (event) {
      /* Whole card toggles; skip links / nested controls inside the answer */
      if (event.target.closest('a, input, textarea, select, button:not(.js-ag-pb-pd-faq-toggle)')) {
        return;
      }

      var card = event.target.closest('.ag-pb-pd__faq-card');
      if (!card || !root.contains(card)) return;

      var item = card.closest('.js-ag-pb-pd-faq-item');
      if (!item) return;

      event.preventDefault();
      toggleItem(root, item);
    });

    root.addEventListener('keydown', function (event) {
      var toggle = event.target.closest('.js-ag-pb-pd-faq-toggle');
      if (!toggle || !root.contains(toggle)) return;
      if (event.key !== 'Enter' && event.key !== ' ') return;
      event.preventDefault();
      var item = toggle.closest('.js-ag-pb-pd-faq-item');
      toggleItem(root, item);
    });

    root.querySelectorAll('.js-ag-pb-pd-faq-item').forEach(function (item) {
      setItemOpen(item, false);
    });
  }

  function initAll(scope) {
    var rootEl = scope && scope.querySelectorAll ? scope : document;
    rootEl.querySelectorAll('[data-ag-pb-pd-faq]').forEach(initBlock);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll(document);
    });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    var section = event.target;
    if (!section) return;
    section.querySelectorAll('[data-ag-pb-pd-faq]').forEach(function (root) {
      root.dataset.agPbPdFaqReady = '';
      initBlock(root);
    });
  });
})();
